







































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";

import _ from "lodash";
import moment from "moment";

import SettlementItemsDetail from "./settlement_items_detail.vue";
import agreement from "@/api/agreement";

@Component({
  components: {
    SettlementItemsDetail
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  form1!: any;

  itemId = 0;

  detailModalVisible = false;
  dateItem={
    dateModalVisible:false,   
    item_id:0,
    type:0,
    start_date:Object(null),
    end_date:Object(null),
    nameModalVisible:false,  
    item_name:'',
  }

  // 项目
  // 普通订单收益+场馆会员卡充值收益+小羽订单收益*0.4+智能场馆*0.4-短信发送费用-人工成本结算总额*0.6
  items: any[] = [];

  // 可选
  optionalItems: any[] = [];

  itemData: any = {};

  addItems: any[] = [];

  beforeCreate() {
    this.form1 = this.$form.createForm(this, {});
  }

  handleAddItem() {
    this.form1.validateFields((err: any, values: any) => {
      if (!err) {
        if(!values.item_id){
          this.$message.error("请选择项目");
          return
        }
        const t:any=_.find(this.addItems,(o:any)=>o.id==values.item_id)
        if(t){
          this.$message.error("该项目已添加过了");
          return
        }
        this.$confirm({
          title: "确认信息",
          content: "你确定要增加吗？",
          onOk: async () => {
            const obj: any = _.find(this.optionalItems, (o: any) => o.id == values.item_id);
            // console.log(obj);
            this.addItems.push({...obj,isBind:false});
          }
        });
      }
    });
  }

  showDetailModal(itemId: number) {
    this.itemId = itemId;
    this.detailModalVisible = true;
  }

  showNameModal(item:any){
    this.dateItem.item_id=item.id;
    this.dateItem.item_name=item.item_name;
    this.dateItem.nameModalVisible = true;
  }

  hideDetailModal() {
    this.detailModalVisible = false;
    this.loadCustom();
  }

  getOptionalItems(){
    console.log('items:',this.optionalItems,this.addItems)
    return this.optionalItems.filter((v,i)=>{
      const obj= this.addItems.find((o,n)=>{
        return o.id==v.id
      })
      if(!obj) return true
      return false
    })
  }

  getValue(obj: any, path: any) {
    const result = _.get(obj, path);
    return result;
  }

  getValue1(obj: any, path: any,desc:boolean=false) {
    let result = _.get(obj, path);
    // console.log(result)
    if (_.isUndefined(result) || result === "0") {
      result = null;
    } else {
      result = moment(result);
    }
    if(!desc){
      return result;
    }
    if(result==null){
      return '--';
    }
    return result.format('YYYY-MM-DD')
  }

  setupDate(item:any,itype:any){
    this.dateItem.item_id=item.id
    const data=_.get(this.itemData, [`${item.id}_${itype}`]);
    this.dateItem.type=itype
    const v=this.getValue(data,['start_time'])
    this.dateItem.start_date=(_.isUndefined(v) || v === "0")?null:moment(v,"YYYY-MM-DD HH:mm:ss")
    const vv=this.getValue(data,['end_time'])
    this.dateItem.end_date=(_.isUndefined(vv) || vv === "0")?null:moment(vv,"YYYY-MM-DD HH:mm:ss")
    this.dateItem.dateModalVisible=true
  }

  handleDateUpdate(e:any){
    this.showTsConfirm({
        title: "确认信息",
        content: "你确定要更新吗？",
        onOk: async () => {
          this.confirmLoading = true;
          // console.log(values)
          const res = await this.$store.dispatch("stadium/settlementSettingSaveDate", {
            stadium_id: this.stadiumId,
            item_id:this.dateItem.item_id,
            item_type:this.dateItem.type,
            start_date:this.dateItem.start_date==null?'':this.dateItem.start_date.format('YYYY-MM-DD'),
            end_date:this.dateItem.end_date==null?'':this.dateItem.end_date.format('YYYY-MM-DD'),
          });
          this.confirmLoading = false;
          if (res && res.Message && res.Message === "success") {
            this.$message.success("操作成功");
            this.loadCustom()
            this.dateItem.dateModalVisible=false
          } else {
            this.$message.error("操作失败");
          }
        }
      });
  }

  handleNameUpdate(e:any){
    this.showTsConfirm({
        title: "确认信息",
        content: "你确定要更新吗？",
        onOk: async () => {
          this.confirmLoading = true;
          // console.log(values)
          const res = await this.$store.dispatch("stadium/settlementSettingSaveName", {
            stadium_id: this.stadiumId,
            item_id:this.dateItem.item_id,
            item_name:this.dateItem.item_name,
          });
          this.confirmLoading = false;
          if (res && res.Message && res.Message === "success") {
            this.$message.success("操作成功");
            let obj=this.optionalItems.find((v,i)=>{
              return v.id==this.dateItem.item_id
            })
            if(obj) obj.item_name=this.dateItem.item_name||obj.name
            let obj2=this.addItems.find((v,i)=>{
              return v.id==this.dateItem.item_id
            })
            if(obj2) obj2.item_name=this.dateItem.item_name||obj2.name
            this.loadCustom()
            this.dateItem.nameModalVisible=false
          } else {
            this.$message.error("操作失败");
          }
        }
      });
  }

  handleSubmit() {
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            // console.log(values)
            for (const key in values) {
              if (_.get(values, [key])) {
                if (moment.isMoment(_.get(values, [key]))) {
                  _.set(values, [key], moment(_.get(values, [key])).format("YYYY-MM-DD HH:mm:ss"));
                }
              }
            }
            const res = await this.$store.dispatch("stadium/settlementSettingSave", {
              stadium_id: this.stadiumId,
              ...values
            });
            this.confirmLoading = false;
            if (res && res.Message && res.Message === "success") {
              this.$message.success("操作成功");

              this.handleCancel();
            } else {
              this.$message.error("操作失败");
            }
          }
        });
      }
    });
  }

  async loadItems() {
    const res = await this.$store.dispatch("stadium/settlementItems", {
      type: 0,
      stadium_id:this.stadiumId,
    });
    if (res && res.Data) {
      this.items = res.Data;
    }
  }

  async loadOptionalItems() {
    const res = await this.$store.dispatch("stadium/settlementItems", {
      type: 1,
      stadium_id:this.stadiumId,
    });
    if (res && res.Data) {
      this.optionalItems = res.Data;
    }
  }

  async loadCustom(){
    // 加载数据
    const res1 = await this.$store.dispatch("stadium/settlementSetting", {
      stadium_id: this.stadiumId
    });
    // console.log(res1)
    if (res1 && res1.Data) {
      this.itemData = res1.Data;
    }
    let oldItems=_.filter(this.addItems,(o:any)=>!o.isBind);
    this.addItems=[];
    _.filter(this.optionalItems, (o: any) => {
      const obj:any=_.find(this.itemData,(t:any)=> o.id==t.item_id );
      if(obj){
          // console.log(obj);
          this.addItems.push({...o,isBind:true});        
      }
    });
    this.addItems.push(...oldItems);
  }

  async mounted() {
    this.spinLoading = true;

    await this.loadItems();

    await this.loadOptionalItems();

    await this.loadCustom();

    this.spinLoading = false;
  }
}
